import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  Router,
  UrlTree
} from '@angular/router';
import { PermissionService } from '../services/permission-service.service';
import { OffsiteEligibilityService } from '../services/offsite-eligibility.service';

@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate {
  constructor(
    private permissionService: PermissionService,
    private router: Router,
    private offsiteEligibility: OffsiteEligibilityService
  ) { }

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    try {
      const requiredPermission = route.data['permission'];
      // Allow route if no specific permission is required (like home public  or unauthorized pages)
      if (!requiredPermission) {
        return true;
      }

      if (requiredPermission === 'offsite') {
        const empData = await this.permissionService.getEmployeeDataAsync();
        return this.offsiteEligibility.isEligible(empData)
          ? true
          : this.router.createUrlTree(['/unauth-message']);
      }

      const perms = await this.permissionService.getPermissionsAsync();
      //console.log(' Required permission is :', requiredPermission);
      //console.log(' Available Perms:', perms);

      // If permissions are still some how missing, fail-safe
      if (!perms) {
        //console.log("no permission set ");
        return this.router.createUrlTree(['/home']);
      }

      //  handle array permissions (any one true = access granted)
      if (Array.isArray(requiredPermission)) {
      const hasAnyPermission = requiredPermission.some(
        (perm) => perms[perm] === true
      );
      return hasAnyPermission
        ? true
        : this.router.createUrlTree(['/unauth-message']);
       }

      // Boolean-based permissions
      if (typeof perms[requiredPermission] === 'boolean') {
        return perms[requiredPermission]
          ? true
          : this.router.createUrlTree(['/unauth-message']);
      }

      //  POA permission 
      if (requiredPermission === 'poa_permission') {
        const validRoles = ['ceo', 'view_all', 'poa', 'legal', 'hod'];
        const userRole = perms.poa_permission;
        return userRole && validRoles.includes(userRole)
          ? true
          : this.router.createUrlTree(['/unauth-message']);
      }

      //  Amdoc permission
      if (requiredPermission === 'amdoc_permission') {
        const level = perms.amdoc_permission;
        return level && level !== 'none'
          ? true
          : this.router.createUrlTree(['/unauth-message']);
      }
    } catch (error) {
      console.error('permission Error:', error);
      return this.router.createUrlTree(['/login']);
    }
  }
}
